import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import {minWidthMedia, EXTRA_LARGE_DESKTOP} from "@irati/ui/src/global/media"
import {Body} from "@irati/ui/src/Typography"

export const SubtitleWrapper = styled.div`
  min-height: 85px;
  max-width: 500px;
  margin-bottom: 50px;
`

export const Subtitle = styled(Body)`
  line-height: 2em;
`

export const Container = styled.div`
  width: 100%;
  height: calc(100vh - 80px);
  background-color: ${({theme}) => theme.colors.utility.white};
  overflow-y: auto;
`

export const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 30px 40px 100px;
`

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 70px;
  background-color: ${({theme}) => theme.colors.primary2};
  padding-right: 15px;
  z-index: 10;

  ${minWidthMedia.extraLargeDesktop`
    width: ${EXTRA_LARGE_DESKTOP}px;
    left: 50%;
    margin-left: -800px;
  `}
`

export const MarginButton = styled(Button)`
  margin-right: 15px;
`
